import RenderIf from "common/components/RenderIf";
import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useWorkspaceMutations from "common/datahooks/useWorkspaceMutations";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import SettingsItemContainer from "../SettingsItemContainer";

export default function DeleteWorkspace() {
  const isDesktop = useTwBreakpoint("lg");
  const {
    id: workspaceId,
    accounts_count,
    license_count,
  } = useSelectedWorkspaceContext();
  const { deleteWorkspace } = useWorkspaceMutations();

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Close = isDesktop ? DialogClose : DrawerClose;
  const Trigger = isDesktop ? DialogTrigger : DrawerTrigger;
  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  const isDisabled = accounts_count > 0 || !!license_count;

  return (
    <SettingsItemContainer className="flex-col lg:flex-row gap-4">
      <div className="flex flex-col gap-y-0.5">
        <span className="text-sm-bold">Delete workspace</span>
        <span className="text-black-500 text-xs-medium">
          Once deleted, your workspace cannot be recovered
        </span>
      </div>
      <Component>
        <Trigger asChild>
          <Button
            variant="outline-danger"
            size={isDesktop ? "sm" : "md"}
            className="ml-auto self-center"
          >
            Delete workspace
          </Button>
        </Trigger>
        <Content className="lg:w-[448px]">
          <Title>
            {isDisabled
              ? "Cannot delete workspace"
              : "Are you sure you want to delete this workspace?"}
          </Title>
          <Description className="mb-4">
            {isDisabled ? (
              <>
                A workspace can only be deleted if it has no added LinkedIn
                accounts, and no active subscription. You must{" "}
                <span className="font-semibold text-black-950">
                  remove all of your LinkedIn accounts and fully terminate your
                  subscription
                </span>{" "}
                to delete this workspace
              </>
            ) : (
              "Deleting this workspace will completely remove all data related to this workspace. This is a non-reversible action"
            )}
          </Description>

          <RenderIf condition={!isDisabled}>
            <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
              <Close asChild>
                <Button
                  size={isDesktop ? "md" : "lg"}
                  variant="secondary-black"
                >
                  Cancel
                </Button>
              </Close>

              <Button
                size={isDesktop ? "md" : "lg"}
                variant="outline-danger"
                onClick={() => deleteWorkspace({ id: workspaceId })}
              >
                Delete
              </Button>
            </div>
          </RenderIf>
        </Content>
      </Component>
    </SettingsItemContainer>
  );
}
